import { twMerge } from 'tailwind-merge';

interface TipsMenuProps {
  show: boolean;
  position: 'above' | 'below';
  onTipClick: (icon: string) => void;
}

const tips = [
  {
    icon: '@',
    label: 'Select Agent',
    description: 'Type @ followed by agent name',
  },
  {
    icon: '$',
    label: 'Search Assets',
    description: 'Type $ followed by asset name or DNS',
  },
  {
    icon: '#',
    label: 'Search Risks',
    description: 'Type # followed by risk name',
  },
  {
    icon: '&',
    label: 'Search Webpages',
    description: 'Type & followed by URL',
  },
  {
    icon: '/',
    label: 'Search Capabilities',
    description: 'Type / followed by capability name',
  },
];

function TipsMenu({ show, position, onTipClick }: TipsMenuProps) {
  if (!show) return null;

  return (
    <div
      className={twMerge(
        'tips-menu-container bg-chariot-background-primary border-chariot-stroke absolute left-0 z-50 w-80 overflow-hidden rounded-lg border shadow-lg sm:w-96',
        position === 'below' ? 'top-full mt-2' : 'bottom-full mb-2'
      )}
    >
      <div className="p-3">
        <div className="text-chariot-text-primary mb-3 text-sm font-semibold">
          Quick Search Shortcuts
        </div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {tips.map((tip, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onTipClick(tip.icon)}
              className={twMerge(
                'hover:bg-chariot-background-secondary w-full rounded px-2.5 py-1.5 text-left transition-colors',
                index === 4 && 'col-span-1 sm:col-span-2'
              )}
            >
              <div className="flex items-center gap-2">
                <code className="bg-chariot-background-secondary flex-shrink-0 rounded px-2 py-1 font-mono text-sm">
                  {tip.icon}
                </code>
                <div className="min-w-0 flex-1">
                  <div className="text-chariot-text-primary text-sm font-medium">
                    {tip.label}
                  </div>
                  <div className="text-chariot-text-secondary text-xs">
                    {tip.description}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TipsMenu;
